export const FILTER_REQUEST = "FILTER_REQUEST"
export const SET_FILTERS = "SET_FILTERS"
export const SET_CATALOG = "SET_CATALOG"
export const SET_BRANDS = "SET_BRANDS"
export const SET_PRODUCTS = "SET_PRODUCTS"
export const SET_CATEGORIES = "SET_CATEGORIES"
export const SET_CONDITIONS = "SET_CONDITIONS"
export const SET_MIN_PRICE = "SET_MIN_PRICE"
export const SET_MAX_PRICE = "SET_MAX_PRICE"
export const SET_MIN_YEAR = "SET_MIN_YEAR"
export const SET_MAX_YEAR = "SET_MAX_YEAR"
export const SET_MIN_SPEC = "SET_MIN_SPEC"
export const SET_MAX_SPEC = "SET_MAX_SPEC"
export const SET_KIT_SOURCE = "SET_KIT_SOURCE"
export const SET_PAGE = "SET_PAGE"
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE"
export const SET_SPEC = "SET_SPEC"
export const FILTER_RECOMMENDATION = "FILTER_RECOMMENDATION"
export const GET_CATEGORY = "GET_CATEGORY"
export const SET_KEYWORDS = "SET_KEYWORDS"
export const SET_CATEGORIES_STRICT = "SET_CATEGORIES_STRICT"
export const GET_FILTER_DISPLAY_SPECS = "GET_FILTER_DISPLAY_SPECS"
export const FILTER_REQUEST_TRADER = "FILTER_REQUEST_TRADER"
export const RESET_FILTER_REQUEST_TRADER = "RESET_FILTER_REQUEST_TRADER"